module.exports = __webpack_public_path__ + "static/media/horizontal_timeline.d8db30cf.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/StartupTimeline/assets/horizontal_timeline.png
// module id = 544
// module chunks = 0